import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { AgVirtualScrollModule } from 'ag-virtual-scroll';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { LibSharedComponentModule } from '../../lib-shared-component.module';
import { SvcValidationMessageModule } from '../../svc-validation-message/svc-validation-message.module';
import { SvcSelectComponent } from './svc-select.component';
import { SvcSelectOptionsFilterByValuePipe } from './svc-select-options-filter-by-value.pipe';

@NgModule({
  declarations: [
    SvcSelectComponent,
    SvcSelectOptionsFilterByValuePipe,
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    SvcValidationMessageModule,
    TranslocoModule,
    AgVirtualScrollModule,
  ],
  exports: [
    SvcSelectComponent,
    SvcSelectOptionsFilterByValuePipe,
  ]
})
export class SvcSelectModule { }
